import React, { useEffect } from "react";
import { Route } from "react-router-dom";

import { Box, Slide } from "@mui/material";
import { Document } from "components/Documents";
import { Form } from "components/Form";
import { useFullScreenBreadcrumbs } from "components/Workspace/useFullScreenBreadcrumbs";
import { Routes } from "constants/routes";

interface Props {
  open: boolean;
}

export const FullScreenRoutes: React.FC<Props> = ({ open }) => {
  const { goBack } = useFullScreenBreadcrumbs();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        goBack();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [goBack]);

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={{ enter: 500, exit: 0 }}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 1300,
          backgroundColor: "#f7f9fc",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Route path={Routes.workspaceDealFolderDocument}>
          <Document onClose={goBack} />
        </Route>
        <Route path={Routes.workspaceFolderDocument}>
          <Document onClose={goBack} />
        </Route>
        <Route path={Routes.workspaceFolderForm}>
          <Form onClose={goBack} />
        </Route>
        <Route path={Routes.workspaceDealFolderForm}>
          <Form onClose={goBack} />
        </Route>
      </Box>
    </Slide>
  );
};
